import { DatePicker } from 'antd'
import React, { useEffect } from 'react'
import TextField from '../../../../core/common/textFields/TextField'
import Select, { StylesConfig } from "react-select";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import { useGetAcceptedSaledInfoByIdQuery } from '../../../../services/EndPointsApis';
import NumberField from '../../../../core/common/textFields/NumberField';
import DateComp from '../../../../core/common/dateComponent/DateComp';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';

const SalesInfoAcceptSaleWizard = ({ formikAcceptedSale, getallActiveUsers, storeProjectId, setAcceptedSaleInfoData }: any) => {
    dayjs.extend(customParseFormat);

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    //get Sale Accepted Api
    const { data: getAcceptedSaleData, refetch: AcceptedsaleInfoRefetch } = useGetAcceptedSaledInfoByIdQuery({ ProjectId: storeProjectId })

    useEffect(() => {
        const pdmJobCost = parseFloat(formikAcceptedSale.values.pdmJobCost);
        const reviewedCost = parseFloat(formikAcceptedSale.values.reviewedCost);
        const salePrice = parseFloat(getAcceptedSaleData?.result?.projectSaleInfo?.salePrice);

        // If either value is empty or invalid, reset markUp to 0
        if (!salePrice || !reviewedCost) {
            formikAcceptedSale.setFieldValue("markUp", 0);
        } else {
            // If both values are valid, calculate the markup
            const markUp = salePrice / reviewedCost;
            formikAcceptedSale.setFieldValue("markUp", markUp.toFixed(2)); // Adjust decimal precision if needed
        }
    }, [formikAcceptedSale.values.pdmJobCost, formikAcceptedSale.values.reviewedCost]);

    const handleDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formikAcceptedSale.setFieldValue('saleAcceptedDate', date ? date.format('YYYY-MM-DD') : null);
    };

    useEffect(() => {
        setAcceptedSaleInfoData(getAcceptedSaleData)
    }, [getAcceptedSaleData])

    const totalNewAmount = getAcceptedSaleData?.result?.projectPaymentSchedule?.reduce(
        (sum: any, apiItem: any) => {
            const newAmount = apiItem?.newAmount;
            const numericValue = typeof newAmount === 'string'
                ? parseFloat(newAmount.replace(/,/g, ''))
                : typeof newAmount === 'number'
                    ? newAmount
                    : 0;
            return sum + numericValue;
        },
        0
    );


    const totalContractAmount = (getAcceptedSaleData?.result?.projectSaleInfo?.salePrice) + (getAcceptedSaleData?.result?.projectSaleInfo?.totalAdendum);
    const totalPaymentDist = getAcceptedSaleData?.result?.projectPaymentSchedule?.reduce(
        (acc: number, item: any) => acc + (parseFloat(item?.newAmount) || 0),
        0
    );
    const remainingAmount = totalContractAmount - totalPaymentDist

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    return (
        <div className='row'>
            <div className='col-md-12'>
                <div className='d-flex gap-2'>
                    <p>
                        Sale Date
                    </p>
                    <p>
                        <DateComp formattedDate={getAcceptedSaleData?.result?.projectSaleInfo?.saleDate} />
                    </p>
                </div>
            </div>
            <h5 className='mb-2'>Job info</h5>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Job Description"
                        type="text"
                        disabled
                        value={getAcceptedSaleData?.result?.projectSaleInfo?.jobDescription}
                    // {...formikAcceptedSale.getFieldProps("jobDiscription")}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Scheduling Notes"
                        type="text"
                        {...formikAcceptedSale.getFieldProps("schedulingNotes")}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Sale Accepted Date <span className="text-danger">*</span>
                </label>
                <div className="form-wrap icon-form">
                    <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                        className="form-control datetimepicker deals-details"
                        onChange={handleDateChange}
                        disabled
                        value={formikAcceptedSale.values?.saleAcceptedDate ? dayjs(formikAcceptedSale.values.saleAcceptedDate, 'YYYY-MM-DD') : null}
                        format='MMM-DD-YYYY'

                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Job Number"
                        type="text"
                        disabled
                        value={getAcceptedSaleData?.result?.projectSaleInfo?.jobNumber}
                    />
                </div>
            </div>
            <h5 className='mb-2 mt-2'>
                Cost Review
            </h5>
            <div className="col-md-6">
                <div className="form-wrap">
                    {/* <NumberField
                        label="PDM Job Cost"
                        type="text"
                        fieldClass="text-end"
                        required
                        name="pdmJobCost"
                        formik={formikAcceptedSale}
                        value={formikAcceptedSale.values.pdmJobCost ===null ? '' :formikAcceptedSale.values.pdmJobCost}
                    /> */}
                    <label className='input-label'>PDM Job Cost <span className='text-danger'>*</span></label>
                    <input
                        type="number"
                        className='form-control text-end'
                        {...formikAcceptedSale.getFieldProps("pdmJobCost")}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Mark Up"
                        type="text"
                        disabled
                        {...formikAcceptedSale.getFieldProps("markUp")}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    {/* <NumberField
                        label="Review Cost Amount"
                        type="text"
                        fieldClass="text-end"
                        required
                        min={0}
                        name="reviewedCost"
                        formik={formikAcceptedSale}
                        value={formikAcceptedSale.values.reviewedCost}
                    /> */}
                    <label className='input-label'>Review Cost Amount <span className='text-danger'>*</span></label>
                    <input
                        type="number"
                        className='form-control text-end'
                        {...formikAcceptedSale.getFieldProps("reviewedCost")}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Reviewed By
                </label>
                <Select
                    styles={customStyles}
                    className="select"
                    options={getallActiveUsers?.result?.
                        map((option: any) => ({
                            label: option?.userName,
                            value: option?.userId
                        }))}
                    value={
                        formikAcceptedSale.values?.reviewedBy?.id
                            ? {
                                value: formikAcceptedSale.values?.reviewedBy?.id,
                                label: formikAcceptedSale.values?.reviewedBy?.value || '',
                            }
                            : null
                    }
                    onChange={(selectedOption: any) => {
                        formikAcceptedSale.setFieldValue('reviewedBy.id', selectedOption.value);
                        formikAcceptedSale.setFieldValue('reviewedBy.value', selectedOption.label);
                    }}

                />
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Cost Review Notes"
                        type="text"
                        {...formikAcceptedSale.getFieldProps("costReviewNotes")}
                    />
                </div>
            </div>
            <h5 className='mt-2 mb-2'>
                Payment Scheduled
            </h5>
            <div className='col-md-5'></div>
            <div className='col-md-7'>
                <div className="col-md-12 mb-2">
                    <div className='d-flex justify-content-between'>
                        <div className='input-label '>
                            Sale Price
                        </div>
                        <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                            <FormattedNumber value={getAcceptedSaleData?.result?.projectSaleInfo?.salePrice} />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mb-2">
                    <div className='d-flex justify-content-between'>
                        <div className='input-label '>
                            Total Addenda Amount
                        </div>
                        <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                            <FormattedNumber value={getAcceptedSaleData?.result?.projectSaleInfo?.totalAdendum} />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mb-2">
                    <div className='d-flex justify-content-between'>
                        <div className='input-label '>
                            Total Contract Amount
                        </div>
                        <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                            <FormattedNumber value={totalContractAmount} />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mb-2">
                    <div className='d-flex justify-content-between'>
                        <div className='input-label '>
                            Total Payment Distribution
                        </div>
                        <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                            <FormattedNumber value={totalPaymentDist} />
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className='d-flex justify-content-between'>
                        <div className='input-label '>
                        </div>
                        <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                            <FormattedNumber value={remainingAmount} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12 '>
                <div className="table-responsive mt-2 overflow-auto">
                    <table className="table datanew dataTable no-footer table-hover">
                        <thead>
                            <tr>
                                <th>
                                    Payment Type
                                </th>
                                <th>
                                    Payment Amt
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {getAcceptedSaleData?.result?.projectPaymentSchedule?.map((apiItem: any, index: number) => {
                                return (
                                    <>
                                        <tr key={apiItem.id}>
                                            {/* Data from saleInfoApi */}
                                            <td>{apiItem?.lst_PaymentType?.value}</td>

                                            {/* Data from saleInfoData */}
                                            <td>
                                                <p>
                                                    <FormattedNumber value={apiItem?.newAmount} />
                                                </p>
                                            </td>
                                        </tr>
                                    </>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default SalesInfoAcceptSaleWizard